module.exports = __webpack_public_path__ + "static/media/project-rpa.02ea436b.jpg";